import _ from 'lodash';
import { ACL } from '.';
import { FranchiseAdminACL } from './franchise_admin';
export const ACL_ROLE_OWNER = 'Franchise Owner';

export const FranchiseOwnerACL: ACL = _.merge({}, FranchiseAdminACL, {
  role: ACL_ROLE_OWNER,
});
